import { FC } from 'react';
import styles from './business-hub-industries-card-block.module.scss';
import Image from 'next/image';
import classNames from 'classnames';
import BusinessYoutubeEmbed from '../business-youtube-embed/business-youtube-embed';
import { COLOR, POSITION } from '../business-button/business-button.constants';
import BusinessButton from '../business-button/business-button';

export interface IndustriesBlockProps {
    afterpayAccessTitle?: string;
    afterpayAccessTitleColor?: string;
    title?: string;
    description?: string;
    icon?: string;
    iconBackground?: string;
    image?: string;
    imageMobile?: string;
    youtubeUrl?: string;
    background?: string;
    textColor?: string;
    ctaText?: string;
    ctaColor?: COLOR;
    ctaDisableBorder?: boolean;
    ctaUrl?: string;
    reversed?: boolean;
}

const BusinessHubIndustriesBlock: FC<IndustriesBlockProps> = (props) => {
    const {
        afterpayAccessTitle,
        afterpayAccessTitleColor,
        title,
        description,
        icon,
        image,
        imageMobile,
        background,
        textColor,
        ctaColor,
        ctaText,
        ctaUrl,
        reversed,
        iconBackground,
        ctaDisableBorder,
        youtubeUrl,
    } = props;

    return (
        <div className={styles.container} style={{ '--bg-color': background, '--icon-bg-color': iconBackground, '--text-color': textColor } as any}>
            <div className={classNames(styles.gird, { [styles.reversed]: reversed }, { [styles.minHeight]: !youtubeUrl })}>
                <div className={classNames(styles.content, { [styles.noPadding]: youtubeUrl })}>
                    {afterpayAccessTitle ? (
                        <div className={styles.heading}>
                            <div className={styles.icon}>{icon && <img src={icon} alt="" />}</div>
                            <div className={styles.text} style={{ color: afterpayAccessTitleColor }}>{afterpayAccessTitle}</div>
                        </div>
                    ) : null}
                    <div className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></div>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>
                    {ctaText && ctaUrl ? (
                        <BusinessButton
                            className={classNames(styles.cta, { [styles.disableBorder]: ctaDisableBorder })}
                            position={POSITION.LEFT}
                            color={ctaColor}
                            link={ctaUrl}
                            buttonText={ctaText}
                            autoMargin={false}
                            target="_blank"
                        />
                    ) : null}
                </div>
                <div className={classNames(styles.illustration, { [styles.bg]: !image && !youtubeUrl })}>
                    {youtubeUrl ? (
                        <div className={styles.youtube}>
                            <BusinessYoutubeEmbed videoUrl={youtubeUrl} className={styles.youtubebox} autoHeight disableMargin />
                        </div>
                    ) : null}
                    {!youtubeUrl && image && (
                        <picture>
                            <source media="(max-width: 998px)" srcSet={imageMobile || image} />
                            <Image
                                src={image}
                                alt=""
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                fill={true}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </picture>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BusinessHubIndustriesBlock;
